import * as React from 'react';
import * as _ from 'lodash';
import { Dispatch, connect } from "react-redux";
import { IApplicationState, AppActionCreators, DashCenterActionCreators } from '@nkr/store/index';
import { ICenter } from '@nkr/models/index';
import RecipientShieldList from './components/recipient-shield-list';
import { IDashCenterLookupDataResponse } from '@nkr/store/donor-intake/actions';

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-bootstrap.css';

interface IOwnProps {
    centerId: number
}

interface IStateProps {
    center: ICenter
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void
}

type TProps = IStateProps & IDispatchProps & IOwnProps;

interface IState {
    selectedIndex: -1
}

class RecipientShield extends React.Component<TProps, IState> {
    handleTabSelect = (key: string) => { }

    render = () => {
        return (
            <div style={{ padding: '0px 10px' }}>

                <div style={{ width: "100%", borderLeft: "1px solid #ddd", borderRight: "1px solid #ddd", borderBottom: "1px solid #ddd", minHeight: "70vh", paddingTop: 20, paddingLeft: 10, paddingRight: 10, marginBottom: 10, backgroundColor: "#FFF" }}>
                    <RecipientShieldList
                        isSuperUser={true}
                        centerId={this.props.centerId}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (appState: IApplicationState, ownProps: IOwnProps): IStateProps => {
    return {
        center: appState.app.center
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(RecipientShield);